import React from "react";
import {useTranslation} from "react-i18next";
import {OrderItemInterface} from "../../services/exports/Interfaces";
import classnames from "classnames";
import LocationCircleIcon from "../../assets/logo/LocationCircleIcon";
import UberEatsIcon from "../../assets/logo/UberEatsIcon";

interface Props {
  order: OrderItemInterface;
  className?: string;
}

export default function DeliveryTracker(props: Props) {
  const { t } = useTranslation(null, {keyPrefix: 'Components:Delivery:DeliveryTracker'});

  const { order, className } = props;

  return order?.delivery?.tracking_url ? (
    <div className={classnames('p-small relative border-medium border-brand-secondary rounded-md', className)}>
      <LocationCircleIcon className="absolute h-8 w-8 right-small top-small"/>
      <h4>{t('title')}</h4>
      <div className="flex mt-mini">
        <p className="my-auto mr-mini">{t('text')}</p>
        <UberEatsIcon className="h-[16px] w-initial my-auto"/>
      </div>
      <a
        href={order.delivery.tracking_url}
        target="_blank"
        rel="noreferrer noopener"
        className="mt-medium block w-full p-xsmall text-center rounded-md bg-brand-inkGrey-grey_6 border border-brand-secondary font-semibold"
      >{t('buttons.track_driver')}</a>
    </div>
  ) : null;
}
